'use strict';

import CartSmall from './components/CartSmall.vue';
import CartSmallRow from './components/CartSmallRow.vue';

export default class {

    constructor() {
        // Register component globaly
        Vue.component('cart-small', CartSmall);
        Vue.component('cart-small-row', CartSmallRow);

    }
}